
export default `
  query getTxn($txnid: ID!) {
    account: whoami {
      id
      username
      creditcard {
        name
        type
        pan
        expdate
        payerid
      }
      person {
        firstname
        lastname
      }
    }

    txn: paymenttxn (txnid: $txnid) {
      owner
      purchaser
      txnid
      txndate
      account {
        person {
          firstname
          lastname
        }
        creditcard {
          name
          type
          pan
          expdate
          payerid
        }
      }
      payment {
        status
      }
      total
    }
    businesskey: integrapaybusinesskey
  }

  query integrapayBusinessKey {
    businesskey: integrapaybusinesskey
  }

  query getStoredCreditCards ($user: ID!) {
    account: account(id: $user) {
      id
      username
      creditcard (foruse: true) { name, type, pan, expdate, payerid }
      person {
        title
        firstname
        lastname
      }
    }
  }
  query getAccountSimple {
    account: whoami { id }
  }

  query getAccount {
    account: whoami { id, creditcard { name, type, pan, expdate,payerid }}
  }

  mutation storeCreditCard ($token: String!, $authorization: String ) {
    card: storecreditcard ( cardtoken: $token, authorization: $authorization ) { name, type, pan, expdate, payerid }
  }

  mutation removeCreditCard($user: AccountUIDScalarType!) {
    status: removecreditcard( id: $user)
  }

  fragment Receipt on IntegrapayReceiptType {
    paymentDate: date,
    type,
    receiptno,
    status,
    statuscode,
    statusmsg,
    paymentAmount: amount,
    transaction{
      txnid,
      txndate,
      invTotal: total,
      status,
      payment {
        status
        date
        method
        subtype
        methoddisplay
        subtypedisplay
      }
      shipping {
        price
      }
      total
      account: owner {
        id
      }
      commissionFactorySignature
      commissionFactoryTimestamp
      first
      agegate
      coupons {
        code
      }
      address {
        billing {
          city
          state
          postcode
          country
        }
      }
      items {
        sku
        unitprice
        qty
        nid
        baseprice
        producer
        product {
          ...on ContentInterface {
            type
          }
          ...on WineProduct {
            wine_type
            varietal
          }
        }
      }
    },
    completepage{
      id,
      type
    }
  }
`
